/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { COMPONENTS_CODE } from '../../assets/ts/data/common-metadata'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import {
  filterBy,
  generateCodeOptionOnLength,
  getMAJCOMCode,
  removeTags,
} from '../../assets/ts/general/general'
import useAnnouncements from '../../hooks/use-announcements'
import { MetadataContext } from '../../store/metadata-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_VALUE,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import { Dropdown, optionsTypes } from '../../utils/controls/select-options-data'

interface DashboardAnnouncement {
  assignComponentCode: number
  categoryCode: number
  content: string
  eKey: string
  extra: string
  id: number
  link: string
  majcomCode: number
  section: string
  sectionCode: number
  subcontent: string
  subcontent1: string
  title: string
}
interface Announcementprops {
  CategoryOptions: optionsTypes[]
  SectionOptions: optionsTypes[]
  filterCategoryValue?: Dropdown
  filterComponentValue?: Dropdown
  filterMajcomValue?: Dropdown
  filterSectionValue?: Dropdown
  isFilters?: boolean
  setCategoryValue: () => void,
  setSectionValue:() => void
}
const Announcements = (props: Announcementprops) => {
  const {
    CategoryOptions,
    SectionOptions,
    filterCategoryValue,
    filterComponentValue,
    filterMajcomValue,
    filterSectionValue,
    isFilters,
    setCategoryValue,
    setSectionValue
  } = props
  const { AnnouncementData } = useAnnouncements({
    isArchived: false,
    isNotExpired: true,
  })
  const { userProfile } = useContext(UserContext)

  const { categories , majcoms } = useContext(MetadataContext)

  const [intialAnnouncement, setIntialAnnouncement] = useState<Array<DashboardAnnouncement>>([])
  const [filtereAnnouncements, setFilteredAnnouncements] = useState<Array<DashboardAnnouncement>>(
    []
  )

  const [filterValues, setFilterValues] = useState({
    assignedComponent: COMPONENTS_CODE.Regular_Air_Force_LABEL,
    assignedComponentCode: COMPONENTS_CODE.Regular_Air_Force,
    category: ALL_SELECT_LABEL,
    categoryCode: ALL_SELECT_VALUE,
    majcom: ALL_SELECT_LABEL,
    majcomCode: ALL_SELECT_VALUE,
    section: ALL_SELECT_LABEL,
    sectionCode: ALL_SELECT_VALUE,
  })
  const [filterCategoryOptions, setFilterCategoryOptions] = useState<Array<optionsTypes>>([])
  useEffect(() => {
    if (!isFilters) {
      const newAnnouncements = intialAnnouncement?.filter(
        ({ CategoryCodes, SectionCodes, assignComponentCode, majcomCode }) => {
          return (
            filterBy(assignComponentCode, filterComponentValue?.value as number) &&
            filterBy(majcomCode, filterMajcomValue?.value as number) &&
            filterBy(SectionCodes.length > 0 ? SectionCodes : -1, 
              filterSectionValue?.value as number) &&
            filterBy(CategoryCodes.length > 0 ? CategoryCodes : -1, 
              filterCategoryValue?.value as number)
          )
        }
      )
      setFilterValues((prev) => ({
        ...prev,
        assignedComponent: filterComponentValue ? filterComponentValue.label : ALL_SELECT_LABEL,
        assignedComponentCode: filterComponentValue
          ? (filterComponentValue.value as number)
          : ALL_SELECT_VALUE,
        category: filterCategoryValue ? filterCategoryValue.label : ALL_SELECT_LABEL,
        categoryCode: filterCategoryValue
          ? (filterCategoryValue.value as number)
          : ALL_SELECT_VALUE,
        majcom: filterMajcomValue ? filterMajcomValue.label : ALL_SELECT_LABEL,
        majcomCode: filterMajcomValue ? (filterMajcomValue.value as number) : ALL_SELECT_VALUE,
        section: filterSectionValue ? filterSectionValue.label : ALL_SELECT_LABEL,
        sectionCode: filterSectionValue ? (filterSectionValue.value as number) : ALL_SELECT_VALUE,
      }))
      setFilteredAnnouncements(newAnnouncements)
    }
  }, [
    intialAnnouncement,
    filterSectionValue?.value,
    filterMajcomValue?.value,
    filterCategoryValue?.value,
    filterComponentValue?.value,
  ])
  useEffect(() => {
    setFilterCategoryOptions(CategoryOptions)
  }, [CategoryOptions])

  function codesNullHandler(code: number) {
    return code ? code : -1
  }
  useEffect(() => {
    if (AnnouncementData.length > 0) {
      const homeAnnouncement: DashboardAnnouncement[] = AnnouncementData?.map((item, index) => ({
        CategoryCodes: item.CategoryCodes,
        SectionCodes: item.SectionCodes,
        assignComponentCode: codesNullHandler(item.AssignedComponentCode),
        content: item.Description,
        eKey: item.eKey,
        extra: '',
        id: index,
        link: '/announcements',
        majcomCode: codesNullHandler(item.ServicingMAJCOMCode),
        section: item.Section,
        subcontent: `Posted Date: ${formatUTCDateToLocal(item.ItemCreated)}  |  Section : ${
          item.Section
        } `,
        subcontent1: '',
        title: item.Title,
      }))
      if (isFilters) {
        const componentCode = userProfile[0].AssignedComponentCode
        const servicingMAJCOMCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
        const newAnnouncements = homeAnnouncement?.filter(({ assignComponentCode, majcomCode }) => {
          return (
            filterBy(assignComponentCode, componentCode) &&
            filterBy(majcomCode, servicingMAJCOMCode)
          )
        })
        setFilterValues((prev) => ({
          ...prev,
          assignedComponentCode: componentCode,
          majcomCode: servicingMAJCOMCode,
        }))
        setIntialAnnouncement(newAnnouncements)
        setFilteredAnnouncements(newAnnouncements)
      } else {
        setIntialAnnouncement(homeAnnouncement)
        setFilteredAnnouncements(homeAnnouncement)
      }
    }
  }, [AnnouncementData])

  const onChangeSection = (e: { label: string; value: number }) => {
    const options: optionsTypes[] =
      e.value === ALL_SELECT_VALUE
        ? CategoryOptions
        : categories
            .filter(({ ParentSectionCode }) => ParentSectionCode === e.value)
            .map(({ Label, Value }) => ({ label: Label, value: Value }))
    if (options.length > 0 && e.value !== ALL_SELECT_VALUE) {
      options.unshift(ALL_SELECT_OPTION)
    }
    setFilterCategoryOptions(options)
    setSectionValue({ label: e.label, vaue: e.value })
    setCategoryValue(ALL_SELECT_OPTION)
    const newAnnouncements = intialAnnouncement?.filter(({ SectionCodes }) => {
      return filterBy(SectionCodes, e.value)
    })
    setFilteredAnnouncements(newAnnouncements)
    setFilterValues((prev) => ({
      ...prev,
      category: ALL_SELECT_LABEL,
      categoryCode: ALL_SELECT_VALUE,
      section: e.label,
      sectionCode: e.value,
    }))
  }

  const onChangeCategory = (e: { label: string; value: number }) => {
    const newAnnouncements = intialAnnouncement?.filter(({ CategoryCodes, SectionCodes }) => {
      return filterBy(SectionCodes, filterValues.sectionCode) && filterBy(CategoryCodes, e.value)
    })

    setCategoryValue({ label: e.label, vaue: e.value })
    setFilteredAnnouncements(newAnnouncements)
    setFilterValues((prev) => ({
      ...prev,
      category: e.label,
      categoryCode: e.value,
    }))
  }
  return (
    <>
      <div className='d-flex align-items-center pb-0 card-header flex-wrap'>
        <div className='d-flex mb-1 title-border'>
          <h2
            aria-label='Announcements'
            className='poppins-bold font-14 title-color20'
            tabIndex={0}
          >
            Announcements
          </h2>
        </div>
        <div className='d-flex ms-auto align-items-center'>
          <div className='ms-auto d-flex align-items-center mb-2 contentfilters flex-wrap'>
            {isFilters && (
              <>
                <div className='mx-1'>
                  <CustomSelect
                    className='form-sm w-100 max-w-sm-80 min-w-sm-80  sourcesanspro font-13 customselect'
                    formClassName='form-horizontal dash poppins-semibold font-11'
                    id='Section'
                    label='Section'
                    name='Section'
                    onChange={onChangeSection}
                    options={SectionOptions}
                    value={filterValues.sectionCode}
                  />
                </div>
                <div className='mx-1'>
                  <CustomSelect
                    className='form-sm w-100 max-w-sm-80 min-w-sm-80  sourcesanspro font-13 customselect'
                    formClassName='form-horizontal dash poppins-semibold font-11'
                    id='Category'
                    label='Category'
                    name='Category'
                    onChange={onChangeCategory}
                    options={filterCategoryOptions}
                    value={filterValues.categoryCode}
                  />
                </div>
              </>
            )}
          </div>

          {filtereAnnouncements.length > 3 && (
            <Link
              className='links-over-underline font-12 links ps-2 ms-auto mb-2'
              state={{
                filterValues: filterValues,
              }}
              title='View All'
              to={`${ROUTE_TYPE}announcements`}
            >
              View All
            </Link>
          )}
        </div>
      </div>
      <div className='d-flex flex-column card-body py-2'>
        <div className='font-13 pe-1 border-none'>
          {filtereAnnouncements.length < 1 ? (
            <div>
            <NO_RESULTS/>
            </div>
          ) : (
            filtereAnnouncements.slice(0, 3).map((announcement) => (
              <div className='mb-3 border-bottom1 pb-1' key={announcement.title}>
                <p className='m-0'>
                  <Link
                    className='title-color1 font-13 poppins-semibold lineClamp1 maxfitcontent'
                    dangerouslySetInnerHTML={{
                      __html: announcement.title
                    }}
                    state={{
                      filterValues: filterValues,
                      itemKey: announcement.eKey,
                    }} 
                    title={announcement.title}
                    to={announcement.link}
                  >
                  </Link>
                </p>
                <p
                  aria-label={announcement.content}
                  className='m-0 lineClamp2 py-1 sourcesanspro sourcesanspro font-13 title-color19 maxfitcontent'
                  tabIndex={0}
                >
                  {removeTags(announcement.content)}
                </p>
                <p
                  aria-label={announcement.subcontent}
                  className='m-0 sourcesanspro subtitle-color2 font-13 maxfitcontent'
                  tabIndex={0}
                >
                  {announcement.subcontent}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  )
}
export default Announcements
